define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'amdi18n-loader?!identity/nls/IdentityEncryptView_strings',
	'lib/jquery',
	'lib/bootstrap/tooltip' // doesn't export
], function (
	Util,
	UiUtil,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * IdentityEncryptView class
	 */
	return function (encryptCallbacks) {
		var _view,
			_minSecretLength = 4;

		_view = (function () {
			var $identityEncryptView = jQuery(
					"<div id='skIdS_identity-encrypt-container'>" +
						"<div>" +
							"<div>" +
								"<div>" +
									"<p>" + Strings.insert_pin_text + ":</p>" +
									"<input id='skIdS_identity-encrypt-first-input' type='password' maxlength='100' tabindex='1' autofocus='autofocus'/>" +
									"<p>" + Strings.repeat_pin_text + ":</p>" +
									"<input id='skIdS_identity-encrypt-repeat-input' type='password' maxlength='100' tabindex='2'/>" +
								"</div>" +
								"<button id='skIdS_identity-encrypt-button' type='button' class='btn btn-default' tabindex='3'>" + Strings.apply_button + "</button>" +
							"</div>" +
							"<span id='skIdS_identity-encrypt-input-error'><span>" +
						"</div>" +
					"</div>");

			function handleInput() {
				var secret = $identityEncryptView.find('#skIdS_identity-encrypt-first-input').val(),
					secretRepeat = $identityEncryptView.find('#skIdS_identity-encrypt-repeat-input').val();

				if (secret.length >= _minSecretLength && secretRepeat.length >= _minSecretLength) {
					$identityEncryptView.find('#skIdS_identity-encrypt-button')
						.tooltip('hide')
						.tooltip('disable');
				} else {
					$identityEncryptView.find('#skIdS_identity-encrypt-button').tooltip('enable');
				}

				$identityEncryptView.find('#skIdS_identity-encrypt-input-error').hide();
			}

			function checkFields() {
				var $secretInput = $identityEncryptView.find('#skIdS_identity-encrypt-first-input'),
					$secretRepeatInput = $identityEncryptView.find('#skIdS_identity-encrypt-repeat-input'),
					$inputError = _view.find('#skIdS_identity-encrypt-input-error');

				if ($secretInput.val() !== $secretRepeatInput.val()) {
					$inputError.empty()
						.append(Strings.error_match_text)
						.show();

					$secretInput.val('');
					$secretRepeatInput.val('');

					return false;
				}

				return true;
			}

			function handleKeyPress(event) {
				var code = event.keyCode || event.which,
					$secretInput = $identityEncryptView.find('#skIdS_identity-encrypt-first-input'),
					$secretRepeatInput = $identityEncryptView.find('#skIdS_identity-encrypt-repeat-input');

				if (code === 13) { // RETURN key
					if ($secretInput.val().length >= _minSecretLength
							&& $secretRepeatInput.val().length >= _minSecretLength
							&& checkFields()) {
						Util.callCallbacks(encryptCallbacks, jQuery(this).val());
					} else if ($secretInput.val().length >= _minSecretLength
							&& $secretRepeatInput.val().length < _minSecretLength) {
						$secretRepeatInput.focus();
					} else {
						$secretInput.focus();
					}
				}
			}

			$identityEncryptView.find('#skIdS_identity-encrypt-first-input')
				.on('input', handleInput)
				.on('keypress', handleKeyPress);

			$identityEncryptView.find('#skIdS_identity-encrypt-repeat-input')
				.on('input', handleInput)
				.on('keypress', handleKeyPress);

			$identityEncryptView.find('#skIdS_identity-encrypt-button')
				.tooltip({ title : Strings.min_secret_length.replace('%%', _minSecretLength) })
				.on('click', function () {
					var secret = $identityEncryptView.find('#skIdS_identity-encrypt-first-input').val(),
						secretRepeat = $identityEncryptView.find('#skIdS_identity-encrypt-repeat-input').val();

					if (secret.length >= _minSecretLength && secretRepeat.length >= _minSecretLength && checkFields()) {
						Util.callCallbacks(encryptCallbacks, $identityEncryptView.find('#skIdS_identity-encrypt-first-input').val());
					}
				});

			$identityEncryptView.find('#skIdS_identity-encrypt-input-error').hide();

			return $identityEncryptView;
		})();


		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function () {
			_view.find('#skIdS_identity-encrypt-first-input').val('');
			_view.find('#skIdS_identity-encrypt-repeat-input').val('');
			_view.find('#skIdS_identity-encrypt-button').tooltip('enable');
			_view.find('#skIdS_identity-encrypt-input-error').empty().hide();
		};

		this.showError = function (error) {
			var $inputError = _view.find('#skIdS_identity-encrypt-input-error');

			$inputError.empty()
				.append(error)
				.show();
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/identity/IdentityEncryptView.js
// module id = 340
// module chunks = 1